import * as utils from './utils';
import File from './File';

export default class Resource {

   static urls = {
      all: '{parentURL}/resources/',
      one: '{parentURL}/resources/{resource}',
      new: '{parentURL}/resources/{resource}?{query}',
   }

   format = 'PSG'

   create = utils.create()
   getFiles = utils.getChildren(File)
   createFile = utils.createChild(File)

   // data = { host, parentURL, project, resource }
   constructor(data) {
      this.initialize(data);
   }

   initialize(data) {
      this.data = utils.rename(data, {
         ID: 'resource',
      });
      this.data.query = this.getQuery();
   }

   getQuery() {
      const format = this.format;
      return `format=${format}`;
   }

}
